function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsThickMuted2I = function SvgNotificationsThickMuted2I(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "m17.587 9.242.013.39-.013.385v3.413l1.2 1.964c.26.425.283.953.063 1.4-.22.465-.686.767-1.2.775h-2.633a3.1 3.1 0 0 1-3.012 2.402 3.1 3.1 0 0 1-2.956-2.189l1.818-1.818 6.39-.001-1.158-1.894a.8.8 0 0 1-.117-.417v-2.805l1.604-1.604zm.66-4.76L4.48 18.247a.9.9 0 1 0 1.273 1.273L19.52 5.754a.9.9 0 1 0-1.273-1.273zm-6.255 13.876a1.51 1.51 0 0 0 1.302-.795h-2.61a1.51 1.51 0 0 0 1.307.795h-.004zM5 16.17a1.46 1.46 0 0 1 .21-.773l1.2-1.967V9.994a5.6 5.6 0 0 1 2.7-5.155A5.6 5.6 0 0 1 12 4.031c1.42 0 2.725.54 3.716 1.425L14.63 6.542a4 4 0 0 0-.503-.374 4 4 0 0 0-2.132-.614 4.03 4.03 0 0 0-4.01 4.01 4 4 0 0 0 .02.404v3.198z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsThickMuted2I);
export default ForwardRef;